import { Button, PlayLineIcon, SourceDataIcon } from '@lokalise/louis'
import overview from '../../../../assets/creation-overview.svg'
import { AI_PROFILES_DOCUMENTATION_URL } from '../../../../constants/url'
import { DynamicRoutingAiIcon } from '../../../AiModelIcon/icons'
import { DescriptionWithIcon } from '../../../DescriptionWithIcon/DescriptionWithIcon'
import {
  StepContainer,
  StepContents,
  StepFooter,
  StepRSP,
  StepSubtitle,
  StepTitle,
  StepTitleContainer,
} from '../../../Step/Step'
import { StyledLink } from '../../../StyledLink/StyledLink'
import styles from './OverviewStep.module.css'

type OverviewStepProps = {
  onNext: () => void
  onClose: () => void
}

export const OverviewStep = ({ onNext, onClose }: OverviewStepProps) => (
  <StepContainer>
    <StepContents>
      <StepTitleContainer>
        <StepTitle>Custom AI profile setup guide</StepTitle>
        <StepSubtitle>
          Custom AI profiles are tailored to your specific content (e.g., legal documents) and
          deliver superior translation quality. Check the{' '}
          <StyledLink href={AI_PROFILES_DOCUMENTATION_URL} rel="noreferrer" target="_blank">
            docs.
          </StyledLink>
        </StepSubtitle>
      </StepTitleContainer>
      <div className="flex-col gap-4">
        <h3 className={styles.heading}>Your steps</h3>
        <DescriptionWithIcon
          title="Phase 1 - Basics & profiles"
          description="Name the profile and set model routing"
          icon={<DynamicRoutingAiIcon size="16px" />}
        />
        <DescriptionWithIcon
          title="Phase 2 - Translation examples & languages"
          description="Choose which past translations to use as examples and the languages that should use them."
          icon={<SourceDataIcon size="16px" />}
        />
        <DescriptionWithIcon
          title="Phase 3 - Activation"
          description="Select the projects which the AI profile should be applied to."
          icon={<PlayLineIcon size="16px" />}
        />
      </div>
      <StepFooter>
        <Button variant="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onNext} variant="primary">
          Next
        </Button>
      </StepFooter>
    </StepContents>
    <StepRSP>
      <img alt="overview" src={overview} />
    </StepRSP>
  </StepContainer>
)
